import { render } from "./InfoTooltip.vue?vue&type=template&id=0704f058&scoped=true"
import script from "./InfoTooltip.vue?vue&type=script&lang=ts"
export * from "./InfoTooltip.vue?vue&type=script&lang=ts"

import "./InfoTooltip.vue?vue&type=style&index=0&id=0704f058&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0704f058"

export default script